import { ServerInfoComponent } from './server-info.component';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../core/modules/shared.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

const routes = [
  {
    path     : 'pages/serverOnService',
    component: ServerInfoComponent
  }
];

@NgModule({
  declarations: [
    ServerInfoComponent
  ],
  imports     : [
    SharedModule,
    CommonModule,
    RouterModule.forChild(routes)
  ]
})

export class ServerInfoModule {}
